import gql from 'graphql-tag'

export const ALL_ORGANISATIONS = gql`
  query allOrganisations($keyword: String!, $includeOrganisationsWithoutProjects: Boolean) {
    allOrganisations(
      keyword: $keyword
      includeOrganisationsWithoutProjects: $includeOrganisationsWithoutProjects
    ) {
      uuid
      tradingName
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/AllOrganisations.tsx